$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');

  // Search Box Customization
  $('.searchBoxInput input').attr('placeholder', 'Search').val('');

  // Email Signup Customization
  const $emailSignup = $('.footer .emailSignup');
  const locationText = window.location.href.includes('fairgrounds') ? 'Fairgrounds' : 'Fair';

  $emailSignup.prepend('<h4>Email Newsletter</h4>');

  $emailSignup
    .find('.emailSignupText')
    .text(`Stay in-the-know about events at The ${locationText}!`);

  $emailSignup.find('.inputFieldTextbox').attr('placeholder', 'Enter Email Address').val('');

  $emailSignup.find('.inputFieldSubmit').text('Subscribe');
});
